import { z } from 'zod';

export const reportBelongedRegistSchema = z.object({
  corporationId: z.preprocess(
    (val) => {
      if (val === null || val === '') {
        return undefined; // null이나 빈 문자열일 경우 undefined 반환
      }
      return Number(val);
    },
    z.number({ required_error: '회사 선택은 필수입니다.' }).refine(
      (val) => !isNaN(val) && val !== 0, // NaN이 아닌 경우에만 유효성 검사를 통과
      {
        message: '회사 선택은 필수입니다.', // 이 메시지는 NaN일 경우에 표시
      },
    ),
  ),
  arrivedAt: z.preprocess((val) => {
    if (typeof val === 'string') {
      const date = new Date(val);
      // 유효한 날짜인지 확인
      if (isNaN(date.getTime())) {
        return undefined; // 유효하지 않은 날짜일 경우 undefined 반환
      }
      return date; // 유효한 날짜일 경우 Date 객체 반환
    }
    return val; // 이미 Date 객체인 경우 그대로 반환
  }, z.date({ required_error: '도착일 선택은 필수입니다.' }).nullable()),
  halfDayAmount: z.preprocess(
    (val) => Number(val),
    z.number({
      required_error:
        '금액 설정은 필수입니다. 마이페이지에서 기본 금액을 설정할 수 있습니다.',
    }),
  ), // preprocess로 숫자로 변환
  fullDayAmount: z.preprocess(
    (val) => Number(val),
    z.number({
      required_error:
        '금액 설정은 필수입니다. 마이페이지에서 기본 금액을 설정할 수 있습니다.',
    }),
  ), // preprocess로 숫자로 변환
  goWorkTime: z.preprocess((val) => {
    if (typeof val === 'string') {
      const date = new Date(val);
      // 유효한 날짜인지 확인
      if (isNaN(date.getTime())) {
        return undefined; // 유효하지 않은 날짜일 경우 undefined 반환
      }
      return date; // 유효한 날짜일 경우 Date 객체 반환
    }
    return val; // 이미 Date 객체인 경우 그대로 반환
  }, z.date({ required_error: '출근시간 선택은 필수입니다.' }).nullable()),
  leaveWorkTime: z.preprocess((val) => {
    if (typeof val === 'string') {
      const date = new Date(val);
      // 유효한 날짜인지 확인
      if (isNaN(date.getTime())) {
        return undefined; // 유효하지 않은 날짜일 경우 undefined 반환
      }
      return date; // 유효한 날짜일 경우 Date 객체 반환
    }
    return val; // 이미 Date 객체인 경우 그대로 반환
  }, z.date({ required_error: '퇴근시간 선택은 필수입니다.' }).nullable()),
  dayType: z
    .string({ required_error: '작업 형태 선택은 필수 입니다.' })
    .refine((val) => val !== null && val !== '', {
      message: '작업 형태 선택은 필수입니다.',
    }),
  ryubeiVolume: z.preprocess((val) => Number(val), z.number()), // preprocess로 숫자로
  cycleVolume: z.preprocess((val) => Number(val), z.number()), // preprocess로 숫자로
  workAmount: z.preprocess((val) => Number(val), z.number()), // preprocess로 숫자로
  ausAmount: z.preprocess((val) => Number(val), z.number()), // preprocess로 숫자로
  ausVolume: z.preprocess((val) => Number(val), z.number()), // preprocess로 숫자로
  refuelingAmount: z.preprocess((val) => Number(val), z.number()), // preprocess로 숫자로
  refuelingVolume: z.preprocess((val) => Number(val), z.number()), // preprocess로 숫자로
  operationDistance: z.preprocess((val) => Number(val), z.number()), // preprocess로 숫자로
  additionAmount: z.preprocess((val) => Number(val), z.number()), // preprocess로 숫자로
  additionComment: z.string(),
  totalAmount: z.preprocess((val) => Number(val), z.number()), // preprocess로 숫자로 변환
});

export const reportRentRegistSchema = z.object({
  corporationId: z.preprocess(
    (val) => {
      if (val === null || val === '') {
        return undefined; // null이나 빈 문자열일 경우 undefined 반환
      }
      return Number(val);
    },
    z.number({ required_error: '회사 선택은 필수입니다.' }).refine(
      (val) => !isNaN(val) && val !== 0, // NaN이 아닌 경우에만 유효성 검사를 통과
      {
        message: '회사 선택은 필수입니다.', // 이 메시지는 NaN일 경우에 표시
      },
    ),
  ),
  arrivedAt: z.preprocess((val) => {
    if (typeof val === 'string') {
      const date = new Date(val);
      // 유효한 날짜인지 확인
      if (isNaN(date.getTime())) {
        return undefined; // 유효하지 않은 날짜일 경우 undefined 반환
      }
      return date; // 유효한 날짜일 경우 Date 객체 반환
    }
    return val; // 이미 Date 객체인 경우 그대로 반환
  }, z.date({ required_error: '도착일 선택은 필수입니다.' }).nullable()),
  ryubeiAmount: z.preprocess((val) => Number(val), z.number()), // preprocess로 숫자로
  cycleAmount: z.preprocess((val) => Number(val), z.number()), // preprocess로 숫자로
  freshWaterAmount: z.preprocess((val) => Number(val), z.number()), // preprocess로 숫자로
  wasteWaterAmount: z.preprocess((val) => Number(val), z.number()), // preprocess로 숫자로
  delayAmount: z.preprocess((val) => Number(val), z.number()), // preprocess로 숫자로

  goWorkTime: z.preprocess((val) => {
    if (typeof val === 'string') {
      const date = new Date(val);
      // 유효한 날짜인지 확인
      if (isNaN(date.getTime())) {
        return undefined; // 유효하지 않은 날짜일 경우 undefined 반환
      }
      return date; // 유효한 날짜일 경우 Date 객체 반환
    }
    return val; // 이미 Date 객체인 경우 그대로 반환
  }, z.date({ required_error: '출근시간 선택은 필수입니다.' }).nullable()),
  leaveWorkTime: z.preprocess((val) => {
    if (typeof val === 'string') {
      const date = new Date(val);
      // 유효한 날짜인지 확인
      if (isNaN(date.getTime())) {
        return undefined; // 유효하지 않은 날짜일 경우 undefined 반환
      }
      return date; // 유효한 날짜일 경우 Date 객체 반환
    }
    return val; // 이미 Date 객체인 경우 그대로 반환
  }, z.date({ required_error: '퇴근시간 선택은 필수입니다.' }).nullable()),
  dayType: z
    .string({ required_error: '작업 형태 선택은 필수 입니다.' })
    .refine((val) => val !== null && val !== '', {
      message: '작업 형태 선택은 필수입니다.',
    }),

  ryubeiVolume: z.preprocess((val) => Number(val), z.number()), // preprocess로 숫자로
  cycleVolume: z.preprocess((val) => Number(val), z.number()), // preprocess로 숫자로

  operationAmount: z.preprocess((val) => Number(val), z.number()), // preprocess로 숫자로

  freshWaterVolume: z.preprocess((val) => Number(val), z.number()), // preprocess로 숫자로
  wasteWaterVolume: z.preprocess((val) => Number(val), z.number()), // preprocess로 숫자로
  delayVolume: z.preprocess((val) => Number(val), z.number()), // preprocess로 숫자로

  lkmStandard: z.preprocess((val) => Number(val), z.number()), // preprocess로 숫자로
  lkmAmount: z.preprocess((val) => Number(val), z.number()), // preprocess로 숫자로
  lkmDistance: z.preprocess((val) => Number(val), z.number()), // preprocess로 숫자로

  kmlStandard: z.preprocess((val) => Number(val), z.number()), // preprocess로 숫자로
  kmlAmount: z.preprocess((val) => Number(val), z.number()), // preprocess로 숫자로
  kmlDistance: z.preprocess((val) => Number(val), z.number()), // preprocess로 숫자로

  ausAmount: z.preprocess((val) => Number(val), z.number()), // preprocess로 숫자로
  ausVolume: z.preprocess((val) => Number(val), z.number()), // preprocess로 숫자로

  refuelingAmount: z.preprocess((val) => Number(val), z.number()), // preprocess로 숫자로
  refuelingVolume: z.preprocess((val) => Number(val), z.number()), // preprocess로 숫자로

  additionAmount: z.preprocess((val) => Number(val), z.number()), // preprocess로 숫자로
  additionComment: z.string(),

  totalAmount: z.preprocess((val) => Number(val), z.number()), // preprocess로 숫자로 변환

  // 추가
  lkmTotalAmount: z.preprocess((val) => Number(val), z.number()), // preprocess로 숫자로 ;
  kmlTotalAmount: z.preprocess((val) => Number(val), z.number()), // preprocess로 숫자로 ;
  ausTotalAmount: z.preprocess((val) => Number(val), z.number()), // preprocess로 숫자로 ;

  // 추가
  freshWaterTotalAmount: z.preprocess((val) => Number(val), z.number()), // preprocess로 숫자로 ;
  refuelingTotalAmount: z.preprocess((val) => Number(val), z.number()), // preprocess로 숫자로 ;
  wasteWaterTotalAmount: z.preprocess((val) => Number(val), z.number()), // preprocess로 숫자로 ;
  delayTotalAmount: z.preprocess((val) => Number(val), z.number()), // preprocess로 숫자로 ;
});

export const transactionStateSchema = z.object({
  startDate: z.date(),
  endDate: z.date(),
  reportType: z.string(),
  name: z.preprocess(
    (val) => {
      if (val === null || val === '') {
        return undefined; // null이나 빈 문자열일 경우 undefined 반환
      }
      return val;
    },
    z.string({ required_error: '회사 선택은 필수입니다.' }).refine(
      (val) => val != null, // NaN이 아닌 경우에만 유효성 검사를 통과
      {
        message: '회사 선택은 필수입니다.', // 이 메시지는 NaN일 경우에 표시
      },
    ),
  ),
});
